export const EXPORT_FORMATS = {
  excel: { extension: "xlsx", label: "Excel" },
  pdf: { extension: "pdf", label: "PDF" },
} as const;

export type ExportKind = keyof typeof EXPORT_FORMATS;

export const SOLD_ITEMS_LABELS = {
  pageTitle: "Listagem de Itens Vendidos",
  pageDescription: "Gere o relatório de itens vendidos por loja e data",
  storeLabel: "Loja",
  storePlaceholder: "Selecione a loja",
  dateLabel: "Data",
  datePlaceholder: "Selecione a data",
  excelButton: "Gerar Excel",
  pdfButton: "Gerar PDF",
  generating: "Enviando…",
  selectFiltersHint: "Selecione a loja e a data para gerar o relatório",
} as const;

export const GLOBALLY_HANDLED_STATUS: ReadonlySet<number> = new Set([
  401, 403, 423,
]);

export const SOLD_ITEMS_MESSAGES = {
  MISSING_FILTERS: {
    description: "Selecione a loja e a data antes de gerar o relatório",
    variant: "destructive" as const,
  },
  EMPTY: {
    description: "Nenhum item vendido para a loja e data selecionadas",
  },
  EXPORT_QUEUED: {
    description:
      "Estamos gerando sua exportação. Ela chegará em {email} e nas suas notificações.",
  },
  ERROR: {
    description: "Não foi possível gerar o relatório",
    variant: "destructive" as const,
  },
};

export const EMAIL_PLACEHOLDER = "{email}";
